import { render, staticRenderFns } from "./ExcluirSaque.vue?vue&type=template&id=bdc07b94&"
import script from "./ExcluirSaque.vue?vue&type=script&lang=ts&"
export * from "./ExcluirSaque.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports